// extracted by mini-css-extract-plugin
export default {"root":"PageTitle_root__rLShr","root_center":"PageTitle_root_center__9vjw1"};